import { useContextState } from "../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: {
            width: '100%',
            height: '100%',
            paddingTop: '50px',
            paddingRight: '40px',
            paddingBottom: '10px',
            overflowY: 'auto',
            overflowX: 'hidden',
            position: 'relative',
        },
        tabs: {
            width: '100%',
            '& .MuiTabs-flexContainer': {
                columnGap: '10px',
                paddingLeft: '48px',
            },
            '& .MuiTab-root': {
                borderTopLeftRadius: '0px',
                borderTopRightRadius: '0px',
                backgroundColor: 'white',
                bordeR: '1px solid black',
                color: colors.color10,
                '& .MuiTabs-scroller': {
                    overflow: 'auto',
                },
                '&.Mui-selected': {
                    backgroundColor: `${colors.color5}`,
                    color: colors.primary,
                    boxShadow: `0 0 2px ${colors.color10}`,
                    fontWeight: '600',
                },
            },
            '& .MuiTabs-indicator': {
                backgroundColor: 'transparent',
            }, marginTop: 1
        },
        areaTitle: {
            fontSize: '12px',
            color: colors.color10,
            display: 'flex',
            alignItems: 'center'
        },
        viewMore: {
            fontSize: '1rem',
            color: colors.color16,
            '& .MuiSvgIcon-root': {
                fontSize: '1em',
            },
        },
        all: {
            display: 'flex',
            alignItems: 'center',
            '& .remove-m': {
                margin: '0px'
            }
        },
        checkLabel: {
            color: colors.color5,
            fontWeigt: '800',
            fontSize: '12px',
            maxWidth: '120px',
            wordBreak: 'break-word'
        },
        action: {
            width: '100%',
            display: 'flex',
            justifyContent: 'start',
            flexWrap: 'wrap',
            '& .MuiCheckbox-root': {
                margin: 0
            }
        },
        mineHeaderTable: {
            '&.MuiTableCell-head': {
                width: '40px',
            },
        },
        headerTable: {
            '&.MuiTableCell-head': {
                minWidth: '100px',
            },
            '&.MuiTableCell-root.MuiTableCell-root': {
                vertialAlign: 'middle',
            },
        },
        flex: {
            display: 'flex',
            alignItems: 'center',
            '&.flex-j-e': {
                justifyContent: 'end',
            },
        },
        circle: {
            width: '10px',
            height: '10px',
            backgroundColor: colors.color13,
            borderRadius: '50%',
            marginLeft: 1
        },
        headerLeft: {
            display: 'flex',
            width: 'fit-content',
            alignItems: 'center',
            '& .MuiIconButton-root': {
                color: colors.color4,
                fontWeight: '600',
                marginLeft: '-10px',
            },
            '& .MuiTypography-root': {
                fontSize: '17px',
                fontWeight: '400',
                color: colors.color4,
            }
        },
        title: {
            fontSize: '22px',
            fontWeight: '500',
        },
        containerTitle:{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 2
        },
        userSelected: {
            color: colors.color1,
            '&.MuiTypography-root': {
                fontSize: '14px'
            }
        },
    }
}

export { useStyles }
